<template>

    <div>
        <PoolGroupList/>
    </div>

</template>


<script>

    import PoolGroupList from './poolgroups/PoolGroupList.vue'

    export default {
        name: "PoolGroup",
        components: {
            PoolGroupList
        },

        data: () => ({}),

        methods: {}
    };

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/PoolGroup.vue